import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import { Link } from "react-router-dom";

import withAjaxStatus from "../../../support/hoc/withAjaxStatus";

import "../schools/List.css";

const formatDate = (value) => {
    if (!value) {
        return "Never";
    }
    const d = new Date(value);
    return isNaN(d.getTime()) ? "Never" : d.toLocaleDateString();
};

const summarizeCriteria = (criteria) => {
    if (!criteria) {
        return "";
    }
    const parts = [];
    if (criteria.schoolIds && criteria.schoolIds.length) {
        parts.push(`${criteria.schoolIds.length} school(s)`);
    }
    if (criteria.grades && criteria.grades.length) {
        parts.push(`${criteria.grades.length} grade(s)`);
    }
    if (criteria.zipCodes && criteria.zipCodes.length) {
        parts.push(`${criteria.zipCodes.length} zip(s)`);
    }
    if (criteria.specialGroupIds && criteria.specialGroupIds.length) {
        parts.push(`${criteria.specialGroupIds.length} group(s)`);
    }
    return parts.length ? parts.join(", ") : "No criteria";
};

class List extends Component {
    static permission = "Admin.Segments";

    componentDidMount() {
        if (this.props.onLoad) {
            this.props.onLoad();
        }
    }

    render() {
        return (
            <div className="admin-institution-list">
                <ReactTable
                    data={this.props.segments}
                    minRows={0}
                    columns={[
                        {
                            Header: "Name",
                            accessor: "name",
                            minWidth: 150,
                        },
                        {
                            Header: "Description",
                            accessor: "description",
                            minWidth: 200,
                        },
                        {
                            Header: "Criteria",
                            id: "criteria",
                            accessor: (row) => summarizeCriteria(row.criteria),
                            minWidth: 160,
                        },
                        {
                            Header: "Last Computed",
                            id: "lastComputedDate",
                            accessor: (row) => formatDate(row.lastComputedDate),
                            maxWidth: 130,
                        },
                        {
                            Header: "",
                            accessor: "id",
                            minWidth: 60,
                            Cell: (row) => {
                                const url = `/admin/segments/${row.value}`;
                                return <Link to={url}>Edit</Link>;
                            },
                        },
                        {
                            Header: "",
                            accessor: "id",
                            id: "delete",
                            minWidth: 70,
                            Cell: (row) => {
                                const segment = row.original;
                                return (
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.props.onDelete(segment);
                                        }}
                                    >
                                        Delete
                                    </a>
                                );
                            },
                        },
                    ]}
                    defaultPageSize={50}
                    className="-striped -highlight"
                />
            </div>
        );
    }
}

List.propTypes = {
    segments: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            description: PropTypes.string,
            lastComputedDate: PropTypes.string,
            criteria: PropTypes.object,
        })
    ),
    onDelete: PropTypes.func.isRequired,
    onLoad: PropTypes.func,
};

List = withAjaxStatus(List);
export default List;
